export default function FormFieldNumber({ formUtility, field, label, description, className, classNameControl, min, max, placeholder, disabled = false, allowNegative = false, integerOnly = false, decimalPlaces = null }) {

    function handleOnKeyDown(event) {
        if (event.key.length !== 1)
            return;

        if ("0123456789.-".indexOf(event.key) < 0)
            event.preventDefault();
        else if (event.key === "-" && (!allowNegative || event.target.selectionStart !== 0 || (event.target.value.includes("-") && !event.target.value.substring(event.target.selectionStart, event.target.selectionEnd).includes("-"))))
            event.preventDefault();
        else if (event.key === "."
            && (integerOnly
                || decimalPlaces === 0
                || !event.target.value
                || event.target.value === ""
                || (decimalPlaces !== null && event.target.value.length - event.target.selectionEnd > decimalPlaces)
                || (event.target.value.includes(".") && !event.target.value.substring(event.target.selectionStart, event.target.selectionEnd).includes("."))))
            event.preventDefault();
        else if (decimalPlaces !== null
            && event.target.value
            && event.target.value.includes(".")
            && event.target.value.length - event.target.value.indexOf(".") > decimalPlaces
            && event.target.selectionEnd - event.target.selectionStart === 0
            && event.target.selectionEnd > event.target.value.indexOf("."))
            event.preventDefault();
    }

    return (
        <div className={className ?? "form-group"}>
            {label?.toString()?.trim().length > 0 ? <label>{label.toString().trim()}</label> : null}
            <input
                name={field}
                value={formUtility.getFieldValue(field)}
                onChange={formUtility.handleChangeControl}
                readOnly={formUtility.fieldsDisabled || disabled}
                disabled={formUtility.fieldsDisabled || disabled}
                min={min}
                max={max}
                placeholder={placeholder}
                onKeyDown={handleOnKeyDown}
                type="text"
                className={classNameControl ?? "form-control"} />
            {description?.toString()?.trim().length > 0 ? <p>{description.toString().trim()}</p> : <br />}
        </div>
    );
}